import React from "react";
import Marquee from "react-fast-marquee";

// Import client images
import client1 from "../assets/images/concepts/jersey-mikes.png";
import client2 from "../assets/images/concepts/rasa.png";
import client3 from "../assets/images/concepts/modo.png";
import client4 from "../assets/images/concepts/model-restaurant-group.png";
import client5 from "../assets/images/concepts/conduiit.png";
import client6 from "../assets/images/concepts/helaina.png";
import client7 from "../assets/images/concepts/logo-1.png";
import client8 from "../assets/images/concepts/logo-2.png";
import client9 from "../assets/images/concepts/logo-3.png";
import client10 from "../assets/images/concepts/neato.png";
import client11 from "../assets/images/concepts/kz_k-studio.png";
import client12 from "../assets/images/concepts/sagamore-blue.png";
import client13 from "../assets/images/concepts/ess-a-bagel.png";
import client14 from "../assets/images/concepts/freddys.webp";
import client15 from "../assets/images/concepts/heritage-grand-bakery.png";


const clients = [
  client1,
  client2,
  client3,
  client4,
  client5,
  client6,
  client7,
  client8,
  client9,
  client10,
  client11,
  client12,
  client13,
  client14,
  client15,
];

const LogoTicker: React.FC = () => {
  return (
    <div id="clients" className="w-full bg-secondary py-10 overflow-hidden">
      <h2 className="text-4xl font-bold mb-12 text-primary text-center">Our Clients</h2>

      <Marquee gradient={false} speed={50} pauseOnHover>
        <div className="flex space-x-6">
          {clients.map((client, index) => (
            <img
              key={index}
              src={client}
              alt={`Client ${index + 1}`}
              className="w-48 h-48 object-contain"
            />
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default LogoTicker;
